import { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import "../../App.css";
import "./SuperMatchMaker.css";
import HeaderBack from "../../components/Header/HeaderBack";
import ManagePlace from "../../components/ManagePlace/ManagePlace";
import LastDataForMatchMaker from "../../components/LastDataForMatchMaker/LastDataForMatchMaker";
import Cookies from "js-cookie";

import axios from "axios";
import {
  getSuperMatchMaker,
  getDoubleCounsler,
  getFamilyCon,
} from "../../handlers/dictionaryHandler.js";
import GetOneProfile from "../../components/GetProfile/GetOneProfile.js";
import GetOneProfileExtra from "../../components/GetProfile/GetOneProfileExtra.js";

// import login from "../login/login.component";

const SuperMatchMaker = () => {
  let history = useHistory();
  const [sendWhatsupp, setSendWhatsupp] = useState("");
  const [cellularToFind, setCellularToFind] = useState("");
  const [emailToFind, setEmailToFind] = useState("");
  const [idByMail, setIdByMail] = useState([]);
  const [monthToAdd, setMonthToAdd] = useState();
  const [editedEmail, setEditedEmail] = useState("");
  const [editedCellular, setEditedCellular] = useState("");
  const [editedFirstName, setEditedFirstName] = useState("");
  const [editedLastName, setEditedLastName] = useState("");
  const [editedGender, setEditedGender] = useState("");
  const [userType, setUserType] = useState("");
  const [showDelUserOption, setShowDelUserOption] = useState(false);
  const [showUpdatePassOption, setShowUpdatePassOption] = useState(false);

  const [userList, setUserList] = useState([]);
  const [listType, setListType] = useState("");
  const [totalRows, setTotalRows] = useState("");
  const [msgToUsers, setMsgToUsers] = useState("");
  const [selectedProfile, setSelectedProfile] = useState("");
  const [stopSendWhatsuppFromDb, setStopSendWhatsuppFromDb] = useState("");
  const [cellMatch, setCellMatch] = useState([]);
  const [editMode, setEditMode] = useState("");
  const [editedHelperFullName, setEditedHelperFullName] = useState("");
  const [editedHelperCellular, setEditedHelperCellular] = useState("");
  const [editedHelperEmail, setEditedHelperEmail] = useState("");
  const [helperCandidates, setHelperCandidates] = useState([]);

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  };

  const showUsers = async (path) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_LOCALHOST_ADDRESS + path,

        config,
      );
      const userData = response.data;
      setTotalRows(userData.length);
      setUserList([...userData]);
    } catch (error) {
      // probebly user is not authenticated or server is down
    }
  };

  const showIdByEmail = async (emailToFind) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/PgetIdByEmail",
        {
          emailToFind: emailToFind,
        },
        config,
      );
      const userData = response.data;
      setIdByMail(userData[0] || []);
    } catch (error) {
      console.log(error);
    }
  };

  const stopSendWhatsapp = async (toStop) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/PstopSendWhatsapp",
        {
          cell: cellularToFind,
          toStop: toStop,
        },
        config,
      );
      if (response.data === true) {
        alert("done toStop " + toStop);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const blockUser = async (toBlock) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/PblockUser",
        {
          cell: cellularToFind,
          toBlock: toBlock,
        },
        config,
      );
      if (response.data === true) {
        alert("done blockUser " + toBlock);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const activeUser = async (activeState) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/PactiveUser",
        {
          cell: cellularToFind,
          activeState: activeState,
        },
        config,
      );
      if (response.data === true) {
        alert("done activeState " + activeState);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const delUser = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/PdelUser",
        {
          cell: cellularToFind,
          reason: "1",
          extraText: "",
        },
        config,
      );
      if (response.data === true) {
        alert("done delUser ");
        setShowDelUserOption(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updatePass = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/PupdatePassSuper",
        {
          cell: cellularToFind,
        },
        config,
      );
      if (response.data === true) {
        alert("done updatePass to abcd1234 ");
        setShowUpdatePassOption(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const vipGift = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/PvipGift",
        {
          cell: cellularToFind,
          mnth: monthToAdd,
          from: 1,
        },
        config,
      );
      if (response.data === true) {
        alert("done vipGift " + monthToAdd);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getHelperDetailsByCell = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/PgetHelperDetailsByCell",
        {
          cell: cellularToFind,
        },
        config,
      );

      const helperData = response.data[0][0];
      const candidatesData = response.data[1] || [];

      if (helperData) {
        setEditedHelperCellular(helperData.cellular || "");
        setEditedHelperEmail(helperData.email || "");
        setEditedHelperFullName(helperData.fullName || "");
        setUserType(helperData.userType || "");
        setHelperCandidates(candidatesData);
      } else {
        alert("לא נמצא דאבליסט לפי הטלפון שהוזן");
        setEditedHelperCellular("");
        setEditedHelperEmail("");
        setEditedHelperFullName("");
        setUserType("");
        setHelperCandidates([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const saveEditedSignUpDetails = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/PeditSignUpDetails",
        {
          cell: cellularToFind,
          editedCellular,
          editedEmail,
          editedFirstName,
          editedLastName,
          editedGender,
        },
        config,
      );
      if (response.data[0].res == 0) {
        alert("done");
      } else {
        alert(
          "יש בעיה בפרטים,נדרש: 1. לעדכן את המשתמש 2. להעביר לבדיקה יסודית בפיתוח",
        );
      }
    } catch (error) {
      console.log(error);
    }
    // console.log(response.data[0][0]);
  };

  const saveEditedHelperDetails = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/PeditHelperDetails",
        {
          cell: cellularToFind,
          editedCellular: editedHelperCellular,
          editedEmail: editedHelperEmail,
          editedFullName: editedHelperFullName,
        },
        config,
      );

      if (response.data[0].res == 0) {
        alert("פרטי הדאבליסט נשמרו בהצלחה");
      } else {
        alert("הטלפון או המייל כבר קיימים לדאבליסט אחר, לא ניתן לעדכן");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const showCellsMatches = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/PshowCellsMatches",

        config,
      );
      const userData = response.data;
      setCellMatch([...userData]);
    } catch (error) {
      // probebly user is not authenticated or server is down
    }
  };

  return (
    <form className="supermatchmaker-form">
      <HeaderBack />
      <br />
      <div
        className={
          getDoubleCounsler() === "0" ? "invisible" : "whitebackground"
        }
      >
        <input
          type="text"
          placeholder="מס טלפון לשליחת ווטסאפ"
          onChange={(e) => setSendWhatsupp(e.target.value)}
        ></input>

        <a
          href={"https://wa.me/972" + sendWhatsupp}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="whatsuplink"></div>
        </a>
      </div>
      <div
        className={
          getSuperMatchMaker() === "0" ? "invisible" : "whitebackground"
        }
      >
        <div className="line" />
        <div className="h5middle">הצגת שם וטלפון לפי סינון</div>
        <div
          className="button-small-letters"
          onClick={() => {
            setMsgToUsers(
              "\n" +
                "! כאן דאבל, " +
                "קיבלת התאמה באתר יש להכנס ולסמן את התשובה " +
                ":) \n" +
                "שימו לב - גם הצד השני קיבל אתכם וממתין לתשובה " +
                "\n\n" +
                " Double2love.com " +
                "\n\n" +
                "להסרה מהתראות ווטסאפ השיבו הסר ",
            );
            setListType("");
            showUsers("/PcellDidntSeeMatchMatchMaker");
          }}
        >
          משתמשים שאמרו להם כן והם לא ראו
        </div>

        <div
          className="button-small-letters"
          onClick={() => {
            setMsgToUsers(
              "\n" +
                "שיתפנו את הכרטיס " +
                "הנה קישור לפייס " +
                "כדאי להיכנס ולסמן לייק ועוקב" +
                ":) \n" +
                "https://www.facebook.com/profile.php?id=100077401852740" +
                "\n\n" +
                "להסרה מהתראות ווטסאפ השיבו הסר ",
            );
            setListType("shareCard");
            showUsers("/PShareCardSuperMatchMaker");
          }}
        >
          משתמשים שביקשו לפרסם כרטיס בסטטוס
        </div>

        <div
          className="button-small-letters"
          onClick={() => {
            setMsgToUsers(
              "\n" +
                "! כאן דאבל, " +
                "ראינו שחסרים לך פרטים באתר על מנת לקבל התאמות." +
                " יש לבדוק בפרט את 'מי אני' בעמוד 3." +
                " ו'מי יכול להתאים לי' עמוד 2." +
                " הנה קישור: " +
                "   Double2love.com ",
            );
            setListType("");
            showUsers("/PHaredUsersDidntFinish");
          }}
        >
          משתמשים חרדים שלא סיימו למלא פרטים
        </div>

        <div
          className="button-small-letters"
          onClick={() => {
            setMsgToUsers(
              "\n" +
                "!כאן דאבל, " +
                "ראינו ששבוע שעבר עניתם כן להצעה מההאתר." +
                " רצינו לשאול אם יש משהו שתרצו לשתף, או האם נפגשתם, וכו," +
                "  כמובן רק אם מתאים לך לשתף.." +
                "המשך יום טוב :)",
            );
            setListType("");
            showUsers("/PcellsDatesBeforeWeek");
          }}
        >
          משתמשים ששבוע שעבר שניהם ענו כן
        </div>

        <div>הודעה: </div>
        <div className="iconsline">{msgToUsers}</div>

        <div className="userline">
          <div> סהכ: {totalRows}</div>
          <div> שם |</div>
          <div> טלפון |</div>
          <div> גיל |</div>
          <div> מנוי? |</div>
          <div> קישור </div>
        </div>

        {userList.map((curUser, index) => {
          return (
            <div key={curUser.cellular} style={{ height: "auto" }}>
              <div className="userline">
                <div>{index + 1} |</div>
                <div>{curUser.rowNum} |</div>
                <div>{curUser.fullName} |</div>
                <div>{curUser.cellular} |</div>
                <div>{curUser.age} |</div>
                <div>{curUser.membership === 1 ? "V" : ""} |</div>

                <div className="whatsupFloata">
                  <a
                    href={`https://wa.me/972${curUser.cellular}?text=הי ${curUser.firstName} ${msgToUsers}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="whatsupTips" />
                  </a>
                </div>
              </div>
              {listType === "shareCard" && (
                <div
                  style={{
                    fontSize: "13px",
                    color: "#666",
                    marginRight: "20px",
                    marginBottom: "6px",
                    textAlign: "right",
                    lineHeight: "1.6",
                  }}
                >
                  {curUser.lastRequestDate && (
                    <div>
                      בקשה אחרונה:{" "}
                      {new Date(curUser.lastRequestDate).toLocaleDateString(
                        "he-IL",
                      )}
                    </div>
                  )}

                  {curUser.personNote && (
                    <div>הערת המשתמש: {curUser.personNote}</div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div
        className={
          getDoubleCounsler() === "0" ? "invisible" : "whitebackground"
        }
      >
        <div className="line" />
        <div className="h5middle">מציאת משתמש לפי אימייל</div>
        <div className="faceline">
          <input
            type="text"
            placeholder="אימייל מזהה לחיפוש"
            // maxLength={10}
            onChange={(e) => setEmailToFind(e.target.value)}
          ></input>

          <div
            className="stopWhatsappBtn"
            style={{ height: "25px", marginRight: "3px" }}
            onClick={() => {
              showIdByEmail(emailToFind);
            }}
          >
            הצג תוצאות
          </div>
        </div>

        <div
          style={{
            width: "100%",
            marginTop: "10px",
            textAlign: "right",
          }}
        >
          {idByMail.length > 0 && (
            <div className="messegeMatch" style={{ fontWeight: "bold" }}>
              תוצאות חיפוש:
            </div>
          )}
          {idByMail.map((row, index) => (
            <div
              key={index}
              className="messegeMatch"
              style={{ marginBottom: "4px" }}
            >
              {row.userTypeName}: {row.fullName} | {row.id}
            </div>
          ))}
        </div>
        <div className="h5middle">הצגת כרטיס לפי מס טלפון</div>
        <input
          type="text"
          placeholder="טלפון מזהה לחיפוש"
          maxLength={10}
          onChange={(e) => setCellularToFind(e.target.value)}
        ></input>

        <div className="faceline">
          <div
            className="stopWhatsappBtn"
            onClick={() => {
              setEditMode("candidate");

              setEditedCellular("");
              setEditedEmail("");
              setEditedFirstName("");
              setEditedLastName("");
              setEditedGender("");
              setUserType("");

              setEditedHelperCellular("");
              setEditedHelperEmail("");
              setEditedHelperFullName("");
              setHelperCandidates([]);

              setSelectedProfile("");
              setTimeout(() => {
                setSelectedProfile(cellularToFind);
              }, 0);
            }}
          >
            הצג פרטי מועמד
          </div>

          <div
            className="stopWhatsappBtn"
            onClick={() => {
              setEditMode("helper");

              setSelectedProfile("");

              setEditedCellular("");
              setEditedEmail("");
              setEditedFirstName("");
              setEditedLastName("");
              setEditedGender("");

              getHelperDetailsByCell();
            }}
          >
            הצג פרטי דאבליסט
          </div>
        </div>
        {userType !== 2 && (
          <div className="faceline">
            <div
              className="stopWhatsappBtn"
              onClick={() => {
                stopSendWhatsapp("1");
              }}
            >
              להפסיק לשלוח ווטסאפ
            </div>
            <div
              className="stopWhatsappBtn"
              onClick={() => {
                stopSendWhatsapp("0");
              }}
            >
              לחזור לשלוח ווטסאפ
            </div>
            <div
              className="stopWhatsappBtn"
              onClick={() => {
                blockUser("1");
              }}
            >
              חסימת משתמש
            </div>
            <div
              className="stopWhatsappBtn"
              onClick={() => {
                blockUser("0");
              }}
            >
              ביטול חסימה
            </div>
          </div>
        )}
        {userType !== 2 && (
          <div className="faceline">
            <div
              className="stopWhatsappBtn"
              onClick={() => {
                activeUser("0");
              }}
            >
              השהיית שימוש
            </div>
            <div
              className="stopWhatsappBtn"
              onClick={() => {
                activeUser("1");
              }}
            >
              לחזור לשימוש
            </div>
            <input
              type="text"
              placeholder="חודשים"
              maxLength={2}
              style={{ width: "40px" }}
              onChange={(e) => setMonthToAdd(e.target.value)}
            ></input>
            <div
              className="stopWhatsappBtn"
              onClick={() => {
                vipGift();
              }}
            >
              מנוי מתנה X חודשים
            </div>
          </div>
        )}
        <div className="faceline">
          {userType !== 2 && (
            <div
              className="stopWhatsappBtn"
              onClick={() => {
                setShowDelUserOption(true);
              }}
            >
              מחיקת משתמש
            </div>
          )}
          <div
            className={showDelUserOption ? "stopWhatsappBtn" : "invisible"}
            onClick={() => {
              delUser();
            }}
          >
            כן למחוק!
          </div>
          <div
            className="stopWhatsappBtn"
            onClick={() => {
              setShowUpdatePassOption(true);
            }}
          >
            עדכון סיסמה דיפולטיבית
          </div>
          <div
            className={showUpdatePassOption ? "stopWhatsappBtn" : "invisible"}
            onClick={() => {
              updatePass();
            }}
          >
            כן לעדכן!
          </div>
        </div>
        <h5> סוג משתמש:** {userType} ** 1-מועמד, 2-דאבליסט, 3-משולב </h5>
        {editMode === "candidate" && (
          <>
            <div className="faceline">
              <input
                type="text"
                maxLength={10}
                value={editedCellular}
                style={{ fontSize: "12px", width: "80px" }}
                onChange={(e) => setEditedCellular(e.target.value)}
              />
              <input
                type="text"
                maxLength={45}
                value={editedEmail}
                style={{ fontSize: "12px" }}
                onChange={(e) => setEditedEmail(e.target.value)}
              />
            </div>

            <div className="messegeMatch">
              שם פרטי | שם משפחה | 1-אישה 2-גבר
            </div>

            <div className="faceline">
              <input
                type="text"
                maxLength={15}
                value={editedFirstName}
                style={{ fontSize: "12px", width: "80px" }}
                onChange={(e) => setEditedFirstName(e.target.value)}
              />
              <input
                type="text"
                maxLength={15}
                value={editedLastName}
                style={{ fontSize: "12px" }}
                onChange={(e) => setEditedLastName(e.target.value)}
              />
              <input
                type="text"
                maxLength={2}
                value={editedGender}
                style={{ fontSize: "12px" }}
                onChange={(e) => setEditedGender(e.target.value)}
              />

              <div
                className="stopWhatsappBtn"
                onClick={() => {
                  saveEditedSignUpDetails();
                }}
              >
                שמירת פרטי מועמד
              </div>
            </div>
          </>
        )}

        {editMode === "helper" && (
          <>
            <div className="faceline">
              <input
                type="text"
                maxLength={10}
                value={editedHelperCellular}
                style={{ fontSize: "12px", width: "80px" }}
                onChange={(e) => setEditedHelperCellular(e.target.value)}
              />
              <input
                type="text"
                maxLength={45}
                value={editedHelperEmail}
                style={{ fontSize: "12px" }}
                onChange={(e) => setEditedHelperEmail(e.target.value)}
              />
            </div>

            <div className="messegeMatch">טלפון| מייל| שם מלא</div>

            <div className="faceline">
              <input
                type="text"
                maxLength={45}
                value={editedHelperFullName}
                style={{ fontSize: "12px", width: "180px" }}
                onChange={(e) => setEditedHelperFullName(e.target.value)}
              />

              <div
                className="stopWhatsappBtn"
                onClick={() => {
                  saveEditedHelperDetails();
                }}
              >
                שמירת פרטי דאבליסט
              </div>
            </div>
            <div style={{ marginTop: "14px" }}>
              <div className="messegeMatch">המועמדים של הדאבליסט</div>

              {helperCandidates.length === 0 ? (
                <div className="messegeMatch">לא נמצאו מועמדים לדאבליסט זה</div>
              ) : (
                helperCandidates.map((candidate) => (
                  <div
                    key={candidate.candidateId}
                    style={{
                      padding: "10px 12px",
                      margin: "8px 0",
                      border: "1px solid #ddd",
                      borderRadius: "12px",
                      backgroundColor: "#fff",
                      fontSize: "13px",
                      lineHeight: "1.7",
                      textAlign: "right",
                    }}
                  >
                    <div>
                      <b>
                        {candidate.firstName} {candidate.lastName}
                      </b>
                      {" | "}
                      גיל: {candidate.age || "-"}
                      {" | "}
                      גישה: {candidate.allowSee === 1 ? "מאושר" : "לא מאושר"}
                    </div>

                    <div>
                      קשר לדאבליסט: {getFamilyCon(candidate.connection) || "-"}
                      {" | "}
                      דאבליסט מתאריך:{" "}
                      {candidate.helperSince
                        ? new Date(candidate.helperSince).toLocaleDateString(
                            "he-IL",
                          )
                        : "-"}
                    </div>
                  </div>
                ))
              )}
            </div>
          </>
        )}
        <div
          className="button-small-letters"
          style={{ backgroundColor: "rgb(56, 205, 56)" }}
        >
          {" "}
          מותר לשלוח ווטסאפ? {stopSendWhatsuppFromDb == 1 ? "לא!" : "כן"}
        </div>
        <div>
          <br />
          {selectedProfile !== "" && (
            <GetOneProfile
              key={`profile-${selectedProfile}`}
              otherId={selectedProfile}
            />
          )}
          {editMode === "candidate" && (
            <div
              className="watermark-text"
              style={{
                width: "80%",
                margin: "-58px auto 0",
                textAlign: "center",
              }}
            >
              מפורסם באישור | Double2love.com שדכן AI
            </div>
          )}
          {selectedProfile !== "" && (
            <GetOneProfileExtra
              key={`extra-${selectedProfile}`}
              otherId={selectedProfile}
              showManagerOnly={true}
              onProfileLoaded={(row) => {
                setEditedCellular(row.cellular || "");
                setEditedEmail(row.email || "");
                setEditedFirstName(row.firstName || "");
                setEditedLastName(row.lastName || "");
                setEditedGender(row.gender || "");
                setUserType(row.userType || "");
              }}
            />
          )}
        </div>
      </div>
      <div
        className={
          getSuperMatchMaker() === "0" ? "invisible" : "whitebackground"
        }
      >
        <div className="line" />
        <LastDataForMatchMaker />
        <div className="line" />
        <ManagePlace />
        <div
          className="button-small-letters"
          onClick={() => {
            showCellsMatches();
          }}
        >
          טלפונים שקיבלו דייט - לשלוח ווטסאפ
        </div>

        {cellMatch.map((cur) => {
          return (
            <div key={cur.cellular} style={{ height: "auto" }}>
              <div className="userline">
                <div>
                  {cur.firstName},{cur.cellular}
                </div>
              </div>
            </div>
          );
        })}

        <div className="line" />

        <Link to="/questionnaires" style={{ textDecoration: "none" }}>
          <div className="button whiteBackNBorder" id="backBtn">
            {" "}
            <b>→</b>
            חזרה
          </div>
        </Link>
      </div>
    </form>
  );
};

export default SuperMatchMaker;
